import {
  useState, useEffect, useCallback, useRef,
  useContext,
} from 'react';
import { useHistory, useLocation, withRouter } from 'react-router-dom';
import { getUserProfile, Profile } from '../../helpers/userProfile';
import {
  Container,
  UserOptions,
  Welcome,
  Expand,
  List,
  Item,
  ItemTitle,
  ContainerLogo,
  ChangeAccess,
  ContainerChangeAccess,
  SwitchIconButton,
  IconChip,
  PermissionContainer,
  CelsiusAiHeaderButton,
  CelsiusAiTooltip,
  HeaderRightSection,
  TooltipContainer,
} from './styles';
import {
  CelciusColorLogo, CelsiusAiMark, SpringerLogo, SmartphoneIcon, DesktopIcon,
} from '~/icons';
import ReactTooltip from 'react-tooltip';
import MenuContext from '~/contexts/menuContext';
import CelsiusAiContext from '~/contexts/celsiusAiContext';
import { useIsCelsiusAiAllowed } from '~/components/CelsiusAIChat/allowedRoutes';
import { getUserClientId } from '~/helpers/getClientsHelper';
import { useAuth } from 'react-oidc-context';
import { t } from 'i18next';
import { LogoutIcon } from '~/icons/Logout';
import { UserGuideIcon } from '~/icons/UserGuide';
import { ConfigIcon } from '~/icons/Config';
import ModalUserGuide from './ModalUserGuide';
import { GlobalSearch } from './GlobalSearch';
import SelectPlataformContext from '../../contexts/selectPlataform';
import { colors } from '~/styles/colors';
import { createPortal } from 'react-dom';
import { CES_SESSION_PREFIX } from '~/pages/RemoteControl/MachineProfile/helpers';

const HeaderComp = ({ history }): JSX.Element => {
  const auth = useAuth();
  const [focus, setFocus] = useState(false);
  const refContainer = useRef<any>(null);
  const [profile] = useState(getUserProfile);
  const [units, setUnits] = useState<{
    UNIT_ID: number;
    UNIT_NAME: string;
    CLIENT_ID: number;
    CLIENT_NAME: string;
    IS_FAVORITE: boolean;
  }[]>([]);
  const { selectPlataform } = useContext(SelectPlataformContext);
  const hasToken = !!localStorage.getItem('@diel:token');
  const { menuToogle } = useContext(MenuContext);// true = open, false = not Open
  const { isCelsiusOpen, setIsCelsiusOpen } = useContext(CelsiusAiContext);
  const isCelsiusAllowed = useIsCelsiusAiAllowed();
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (refContainer.current && !refContainer.current.contains(event.target)) {
      setFocus(false);
    }
  }, []);
  const [clientIds, setClientIds] = useState<number[] | null>(null);
  const [showUserGuide, setShowUserGuide] = useState(false);
  const [initialGuideTab, setInitialGuideTab] = useState<'pdf' | 'video' | 'alerts' | 'remoteControl'>('alerts');
  const location = useLocation();
  const logout = async () => {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith(CES_SESSION_PREFIX))
      .forEach((key) => sessionStorage.removeItem(key));
    await auth.signoutRedirect({ post_logout_redirect_uri: process.env.REACT_APP_KEYCLOAK_LOGOUT_REDIRECT_URL });
  };

  useEffect(() => {
    getUserClientId({ profile, setClientIds });
  }, []);

  useEffect(() => {
    const guia = new URLSearchParams(location.search).get('guia');
    if (guia === 'video' || guia === 'pdf' || guia === 'alerts' || guia === 'remoteControl') {
      setInitialGuideTab(guia);
      setShowUserGuide(true);
    }
  }, [location.search]);

  useEffect(() => {
    focus
      ? document.addEventListener('mousedown', handleClickOutside)
      : document.removeEventListener('mousedown', handleClickOutside);
  }, [focus, handleClickOutside]);

  function getUserName() {
    // Only users created directly in the database do not have a lastName,
    // as it is required when registering/editing through the system.
    const lastName = profile.lastName ?? '';
    return `${profile.name} ${lastName}`;
  }

  function handleClickLogo() {
    if (profile.manageAllClients) {
      history.push('/analise/unidades');
      return;
    }

    history.push('/visao-geral');
  }

  /* 157 - Atacadão 158 - Carrier */
  const showLogoCelsius = (clientIds && (clientIds.length === 0 || clientIds.some((item) => (item !== 157 && item !== 158))) || profile.permissions.isAdminSistema);
  const showLogoSpringer = (clientIds && clientIds.length > 0 && clientIds.filter((item) => (item !== 157 && item !== 158)).length === 0 && !profile.permissions.isAdminSistema);

  const selectedRemoteControl = selectPlataform === '/controle-inteligente';
  return (
    <>
      <Container MenuOpen={menuToogle} CelsiusOpen={isCelsiusOpen}>
        <ContainerLogo style={{ padding: menuToogle ? '0px 0px 0px 203px' : '0px 35px' }}>
          { (profile.permissions.isPersonaII && showLogoCelsius) && <ChangeProfile />}
          { (!profile.permissions.isPersonaII && showLogoCelsius) && (
            <button type="button" style={{ cursor: 'pointer', background: 'none', border: 'none' }} onClick={handleClickLogo}>
              <CelciusColorLogo />
            </button>
          ) }
          {showLogoSpringer && (
            <button type="button" style={{ cursor: 'pointer', background: 'none', border: 'none' }} onClick={handleClickLogo}>
              <SpringerLogo color="black" />
            </button>
          )}
          { !(profile.permissions.isPersonaII && selectedRemoteControl) && <GlobalSearch setUnits={setUnits} />}
        </ContainerLogo>
        {/* <CustomLogo style={{ marginRight: '20px' }} src={CelciusLogoWhiteBallWhite} alt="logoDiel" /> */}
        {hasToken && (
        <HeaderRightSection>
          {isCelsiusAllowed && (
            <CelsiusAiHeaderButton
              onClick={() => setIsCelsiusOpen(!isCelsiusOpen)}
              type="button"
              data-active={isCelsiusOpen}
              data-testid="celsius-ai-open"
            >
              <CelsiusAiMark size={28} white={isCelsiusOpen} />
              <CelsiusAiTooltip>{isCelsiusOpen ? t('celsiusAiFechar') : t('celsiusAi')}</CelsiusAiTooltip>
            </CelsiusAiHeaderButton>
          )}
          <UserOptions>
            <div ref={refContainer} onClick={() => setFocus(!focus)}>
              <Welcome>
                {t('bemVindo')}
                {', '}
                <strong>{getUserName()}</strong>
              </Welcome>
              <Expand color="" expanded={focus} />
              {focus && (
                <List>
                  <Item onClick={() => setShowUserGuide(true)}>
                    <UserGuideIcon />
                    <ItemTitle>{t('guiaDoUsuario')}</ItemTitle>
                  </Item>
                  <div style={{ width: '100%', borderBottom: '1px solid #74747433' }} />
                  <Item onClick={() => history.push('/configuracoes')}>
                    <ConfigIcon />
                    <ItemTitle>{t('configuracoes')}</ItemTitle>
                  </Item>
                  <Item onClick={logout}>
                    <LogoutIcon />
                    <ItemTitle>{t('sair')}</ItemTitle>
                  </Item>
                </List>
              )}
            </div>
            <PermissionContainer>
              <h1 onClick={() => history.push('/configuracoes/editar')}>{profile.profileSim && `${t('perfilSimulado')} | `}</h1>
              <span>{getClientName(profile, units)}</span>
              <span>{getUserRole(profile)}</span>
            </PermissionContainer>
          </UserOptions>
        </HeaderRightSection>
        )}

      </Container>
      {showUserGuide && (
        <ModalUserGuide handleCloseModal={() => setShowUserGuide(false)} menuToggle={menuToogle} initialTab={initialGuideTab} />
      )}

    </>
  );
};

export function getClientName(profile: Profile, units: {
    UNIT_ID: number;
    UNIT_NAME: string;
    CLIENT_ID: number;
    CLIENT_NAME: string;
    IS_FAVORITE: boolean;
  }[]) {
  const clients = units.reduce((acc, item) => {
    acc[item.CLIENT_ID] = item.CLIENT_NAME;
    return acc;
  }, {});
  if (profile.manageMultipleClients) return '';
  if (profile.permissions.PER_CLIENT.length === 1 && clients[profile.permissions.PER_CLIENT[0].clientId]) {
    return `${clients[profile.permissions.PER_CLIENT[0].clientId]} -`;
  }
  if (profile.permissions.PER_UNIT) {
    const listClients: number[] = [];
    profile.permissions.PER_UNIT.forEach((item) => {
      listClients.push(item.clientId);
    });
    if (listClients.length === 1 && clients[listClients[0]]) return `${clients[listClients[0]]} -`;
  }
  return '';
}

const profileMap: Record<string, string> = {
  '[SA]': t('superAdmDiel'),
  '[HM]': t('gerenciadorSaude'),
  '[A]': t('administradorDiel'),
  '[ADMC]': t('administradorDeConta'),
  '[D]': t('demonstracao'),
  '[MN]': t('mantenedor'),
  '[PV]': t('parceiroValidador'),
  '[I]': t('Instalador'),
  '[API]': t('administradorAPI'),
  '[CP]': t('administradorAutomacao'),
  '[C]': t('administrador'),
  '[RC]': t('operadorControleRemoto'),
  '[U]': t('usuario'),
  '[IS]': t('integradorOrdemServicos'),
};

function getUserRole(perms: Profile) {
  if (perms.permissions.isSuperAdmin) return profileMap['[SA]'];
  if (perms.permissions.isAdminSistema) return profileMap['[A]'];
  if (perms.permissions.HEALTH_MANAGEMENT) return profileMap['[HM]'];
  const profiles: string[] = [];
  perms?.permissions.PER_UNIT?.forEach((unit) => {
    profiles.push(...unit.p);
  });
  perms?.permissions.PER_CLIENT?.forEach((client) => {
    profiles.push(...client.p);
  });
  for (const code of Object.keys(profileMap)) {
    if (profiles.some((p) => p.includes(code))) {
      return profileMap[code];
    }
  }
  return '';
}

export function ChangeProfile({ isMobile = false }) {
  const [focus, setFocus] = useState(false);
  const history = useHistory();
  const refContainer = useRef<any>(null);
  const { setSelectPlataform } = useContext(SelectPlataformContext);
  const profile = getUserProfile();
  const perUnitUnits = profile.permissions.PER_UNIT?.flatMap((x) => x.units) ?? [];

  const isInControle = history.location.pathname.startsWith('/controle-inteligente');
  const DestinationIcon = isInControle ? DesktopIcon : SmartphoneIcon;
  const destinationLabel = isInControle ? t('gestaoInteligente') : t('controleInteligente');
  const tooltipText = `${t('trocarPara')} ${destinationLabel}`;

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (refContainer.current && !refContainer.current.contains(event.target)) {
      setFocus(false);
    }
  }, []);

  useEffect(() => {
    focus
      ? document.addEventListener('mousedown', handleClickOutside)
      : document.removeEventListener('mousedown', handleClickOutside);
  }, [focus, handleClickOutside]);

  function select(path: string) {
    localStorage.setItem('choosePlataform', path);
    setSelectPlataform(path);
    history.push(path);
  }

  function selectGestaoInteligente() {
    let path = '/analise/unidades';
    if ((profile.permissions.PER_CLIENT?.length ?? 0) === 0 && perUnitUnits.length === 1) {
      path = `/analise/unidades/${perUnitUnits[0]}`;
    }
    select(path);
  }

  function handleLogoClick() {
    if (profile.manageAllClients) {
      history.push('/analise/unidades');
      return;
    }
    selectGestaoInteligente();
  }

  function handleSwitchPlatform() {
    if (isInControle) {
      selectGestaoInteligente();
    } else {
      select('/controle-inteligente');
    }
  }

  if (!isMobile) {
    return (
      <ContainerChangeAccess data-testid="controle_inteligente-tag-alterar_visualizacao-ambas-visualizacoes">
        <SwitchIconButton
          type="button"
          data-tip={tooltipText}
          data-for="switch-platform-tooltip"
          onClick={handleSwitchPlatform}
        >
          <DestinationIcon color={colors.icon['primary-base']} size={20} />
        </SwitchIconButton>
        {createPortal(
          <TooltipContainer>
            <ReactTooltip
              id="switch-platform-tooltip"
              place="bottom"
              effect="solid"
            />
          </TooltipContainer>,
          document.body,
        )}
        <button type="button" style={{ cursor: 'pointer', background: 'none', border: 'none' }} onClick={handleLogoClick}>
          <CelciusColorLogo />
        </button>
      </ContainerChangeAccess>
    );
  }

  return (
    <ContainerChangeAccess ref={refContainer} data-testid="controle_inteligente-tag-alterar_visualizacao-ambas-visualizacoes">
      <SwitchIconButton type="button" onClick={() => setFocus((prev) => !prev)}>
        <DestinationIcon color={colors.icon['primary-base']} size={20} />
      </SwitchIconButton>
      {focus && (
        <ChangeAccess>
          <p>{t('alterarAcesso')}</p>
          <div
            data-testid="controle_inteligente-tag-alterar_visualizacao_para_controle_inteligente-visualizacao_celsius"
            onClick={() => { handleSwitchPlatform(); setFocus(false); }}
          >
            <IconChip><DestinationIcon color="white" size={20} /></IconChip>
            <span>{destinationLabel}</span>
          </div>
        </ChangeAccess>
      )}
    </ContainerChangeAccess>
  );
}

const Header = withRouter(HeaderComp);

export { Header };
